<template>
  <div class="h-full flex" ref="container">
    <!-- 侧边栏 -->
    <template v-if="!hiddenAside">
      <interview-search-list
        @select-side="selectSide"
        :isActive="isActive"
        :tabsSearchList="tabsSearchList"
        :tabsSearchKey="tabsSearchKey"
        :tabsLoading="tabsLoading"
        @search-change="searchChange"
      ></interview-search-list>
    </template>
    <!-- 主要内容 -->
    <div class="main flex-1">
      <el-row>
        <el-col class="box">
          <el-card class="box-card border-0 bg-card-bg-gray rounded-none">
            <div class="rate">
              <span>人工审核合格率</span>
              <el-tooltip :content="tooltips.examineRate" effect="light" placement="top" style="cursor: pointer"
                ><i class="iconfont icon-shuoming text-theme-black-350 cursor-pointer text-medium"></i></el-tooltip
              >：
              <div class="rate-num">{{ examineRate }}%</div>
            </div>
            <div class="man-made">
              人工审核通过
              <span class="text-theme">{{ showParams.manualQcPassedNum }}</span> 份，人工拒绝
              <span class="text-danger">{{ showParams.manualQcFailedNum }}</span> 份
            </div>
            <div class="all-buttons pl-4">
              <el-tooltip placement="bottom">
                <div slot="content" style="text-indent: 25px">
                  <template v-for="pa in tooltips.passedAll"> {{ pa }} <br /> </template>
                </div>
                <el-button size="small" type="primary" @click="openOneBtn('agree')">一键通过所有</el-button>
              </el-tooltip>
              <span class="ml-3">
                <el-button size="small" type="danger" @click="openOneBtn('refuse')">一键拒绝所有</el-button>
              </span>
            </div>
            <div class="text-red leading-22 text-medium ml-20 -mt-px pt-3" v-if="searchFormBak.channel[0] === '12'">
              样本服务回收答卷不足，请 
              <el-popover placement="top-start" trigger="hover">
                <div style="width: 150px; height: 150px">
                  <img src="/assets/img/code/Mrs.Chai.png" class="w-full h-full" />
                </div>
                <span class="text-theme cursor-pointer" slot="reference">联系管理员</span>
              </el-popover>
               追加样本
            </div>
          </el-card>
        </el-col>
      </el-row>
      <el-row class="query-cond">
        <el-col class="query-cond-item" style="width: 240px">
          <el-date-picker
            v-model="searchForm.date"
            type="daterange"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="提交时间"
            end-placeholder="提交时间"
            size="small"
          ></el-date-picker
        ></el-col>
        <el-col class="query-cond-item w-32">
          <el-cascader v-model="searchForm.channel" :options="channelOptions" placeholder="回收渠道" clearable size="small"></el-cascader>
        </el-col>
        <el-col class="query-cond-item w-32">
          <el-cascader
            placeholder="答题位置"
            size="small"
            :options="citylist"
            :props="{
              checkStrictly: true,
              expandTrigger: 'hover'
            }"
            clearable
            filterable
            v-model="searchForm.position"
          ></el-cascader>
        </el-col>
        <el-col class="query-cond-item" style="width: 240px">
          <el-date-picker
            v-model="searchForm.answerDate"
            type="datetimerange"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            range-separator="至"
            prefix-icon="el-icon-date"
            :default-time="['00:00:00', '23:59:59']"
            size="small"
            style="width: 100%"
            value-format="yyyy-MM-dd HH:mm:ss"
            format="yyyy-MM-dd HH:mm:ss"
          ></el-date-picker>
        </el-col>
        <el-col class="query-cond-item w-32">
          <el-input
            placeholder="答卷ID"
            size="small"
            v-model="searchForm.answerSheetId"
            @keyup.enter.native="submitTable"
            clearable
          >
          </el-input>
        </el-col>
        <el-col class="query-cond-item text-left w-auto">
          <span class="mr-3">
            <el-button size="small" type="primary" @click="submitTable">查询</el-button>
          </span>
          <el-button size="small" @click="cancelTable" :disabled="isCancelBtnDisabled">重置</el-button>
        </el-col>
      </el-row>
      <el-row>
        <el-col class="tips pl-4 text-medium leading-22 text-theme-black-650">
          <span v-if="getInerviewer !== '全部未审答卷'"
            >调查员“<span class="text-theme">{{ getInerviewer }}</span
            >”，</span
          >符合条件的“未审核”答卷共 <span class="i">{{ eligibleTotal }}</span> 份，从中抽取
          <span class="i">{{ page.total }}</span> 份审核。（<span class="re-select" @click="reExtractionVisible = true"
            >重新抽取</span
          >）
          <el-button type="primary" size="mini-x" @click="openBatchAuditId">批量审核答卷ID</el-button>
        </el-col>
      </el-row>
      <!-- 审核列表 -->
      <data-table
        class="mx-4"
        ref="examine-data-table"
        :rowClassName="rowClassName"
        align="left"
        selection
        :height="tableHeight"
        :loading="tableLoading"
        :data="answerDatas"
        :columns="finalColums"
        :page="page"
        :showPage="true"
        @selection-change="selectionChange"
        @size-change="sizeChange"
        @pagination-current-change="currentChange"
      >
        <template #num="{ row, $index }">
          <div>{{ page.pageSize * (page.currentPage - 1) + ($index + 1) }}</div>
        </template>
        <template #complexId="{ row }">
          <div>{{ row.accountUserId || row.accountUserOpenId || row.accountUserFingerprint }}</div>
        </template>
        <template #surveyRegion="{ row }">
          <div v-truncate="row.surveyRegion"></div>
        </template>
        <template #channel="{ row, index }">
          <div v-truncate="channel_list_options[row.channel]"></div>
        </template>
        <template #answerChannel="{ row }">
          <div v-truncate="row.answerChannel"></div>
        </template>
        <template #Explain="{ row }">
          <div v-truncate="row.Explain || ''"></div>
        </template>
        <template #opt="{ row, $index }">
          <el-button type="text" size="small" @click="openExamineDrawer(row, $index)">审核</el-button>
        </template>
        <template #page-left>
          <div class="flex text-medium leading-22 text-theme-black-650">
            <p>
              已选择<span class="text-theme">{{ checkList.length }}</span
              >项
            </p>
            <el-row v-if="!isSmartStore" style="margin-top: -7px" class="ml-6">
              <el-button size="small" type="primary" @click="handlePass">通过</el-button>
              <el-button size="small" type="danger" @click="handleRefuse">拒绝</el-button>
            </el-row>
            <el-row v-if="isSmartStore" style="margin-top: -7px" class="ml-6">
              <el-button size="small" type="primary" @click="openSmartStore">审核</el-button>
            </el-row >
          </div>
        </template>
      </data-table>
    </div>
    <detail-drawer
      :isEdit="true"
      :auditDetailVisible.sync="auditDetailVisible"
      :currentAnswerId.sync="currentAnswerId"
      :curAnswerIndex.sync="curAnswerIndex"
      :answerDatas.sync="answerDatas"
      :surveyFinishTime="surveyFinishTime"
      :page="page"
      @getPageData="getPageData"
      @refreshCurrentTableData="getTableData"
    ></detail-drawer>
    <!-- 重新抽取 弹层 -->
    <el-dialog
      class="reselect-dialog"
      title="设置抽审比例"
      :visible.sync="reExtractionVisible"
      @close="closeReExtractionDialog"
      width="600px"
    >
      <div class="title">
        符合当前条件的“未审核”答卷共
        <span>{{ eligibleTotal }}</span> 份，从中抽取：
      </div>
      <div class="extraction">
        <el-input v-model="extractionPercent"></el-input><span style="color: #333">%</span>&nbsp;&nbsp;<span style="color: #999"
          >或</span
        >&nbsp;&nbsp; <el-input v-model="extractionNumber"></el-input><span style="color: #333">份</span>
      </div>
      <div style="text-align: right">
        <el-button class="normal-button" @click="reExtractionVisible = false">取消</el-button>
        <el-button type="primary" class="normal-button" @click="selectExtraction">确定</el-button>
      </div>
    </el-dialog>

    <!-- 一键通过 /一键拒绝 弹层 -->
    <!-- 批量通过/批量拒绝 弹层 -->
    <audit-dialog :visible.sync="mulAuditBtn.dialogVisible" :title="mulAuditBtn.title" :type="mulAuditBtn.type" :eligibleTotal="eligibleTotal" @confirm="confirmMulExamineDialog(mulAuditBtn.type, $event)" :confirmLoading.sync="mulAuditBtn.loading"/>

    <!-- 批量审核答卷id 弹层 -->
    <el-dialog
      class="theme-dialog dialog-center dialog-body-0"
      title="批量输入答卷ID"
      top="0"
      :visible.sync="batchAuditIdVisible"
      width="60%"
      :modal="false"
    >
      <div>
        <div class="inputb px-6 py-4">
          <el-input
            type="textarea"
            class="textarea"
            placeholder="请参考以下格式输入（每行一个答卷ID）：
559781177804718080
559421575758086144
559365980858351616
559365917054599168"
            v-model="batchAuditIdValue"
          >
          </el-input>
        </div>
      </div>
      <div class="btn-footer">
        <el-button @click="batchAuditIdRefuse" style="width: 88px">批量拒绝</el-button>
        <el-button type="primary" @click="batchAuditIdPass" style="width: 88px">批量通过</el-button>
      </div>
    </el-dialog>
    <!-- 智能门店审核弹层 -->
    <SmartStoreAudit :visible.sync="smartStoreVisible" :answerIds="checkList.map(curVal => curVal.id)" :surveyFinishTime="surveyFinishTime" @add-audit-success="addAuditSuccess"/>
    <!-- 人脸识别提示弹层 -->
    <FaceRecognition :visible.sync="faceRecognitionVisible"/>
  </div>
</template>

<script>
import citylist from '@/assets/js/config/citydata'
import GlobalConfig from '@/global/config'
import {
  getTotalCount, // 侧边栏接口
  getSamplingData, // 获取审核答卷数据列表
  reSelect, // 重新抽取 弹层确定
  auditBatch // 一键通过 /一键拒绝
} from '@/api/wenjuan/qualityControl'
import { handleMultiAudit } from '@/api/wenjuan/multiAudit' // 批量通过/批量拒绝
import { deepClone } from '@/assets/js/utils.js'
import isequal from 'lodash.isequal'
import { channel_list_options } from '@/components/survey-detail/config/index.js'
import { getStore } from '@dygc/shared'
import DataTable from '@/components/base/DataTable'
import { columns } from './config/columns.js'
import InterviewSearchList from '@/components/survey-detail/components/InterviewSearchList.vue'
import { Message } from 'dygc-ui'
// const DetailDrawer = () => import('@/components/survey-detail/DetailDrawer.vue')
const DetailDrawer = () => import('@/components/survey-detail/NewDetailDrawer.vue')
import SmartStoreAudit from '@/components/survey-detail/components/SmartStoreAudit'
import AuditDialog from '@/components/survey-detail/components/AuditDialog'
import { querySampleServiceByUser } from "@/api/wenjuan/sampleService"
import { subChannel } from '@/api/wenjuan/answerList'
import FaceRecognition from '@/components/survey/FaceRecognition'
import mixin from '@/views/survey/analysis/mixins/faceRecognition.js'
import pageView from '@/mixins/pageView.js'
export default {
  name: 'PendingReview',
  mixins: [mixin,pageView],
  components: {
    InterviewSearchList,
    DataTable,
    DetailDrawer,
    SmartStoreAudit,
    AuditDialog,
    FaceRecognition
  },
  data() {
    return {
      citylist,
      columns,
      channel_list_options,
      isequal,
      tableHeight: null, // 定制表格高度
      // 分页配置选项
      page: {
        pageSizes: [10, 20, 30, 40, 50, 100],
        currentPage: 1,
        pageSize: 20,
        total: 0
      },
      // 侧边栏显示 未经过滤的原始数据
      tabsList: [],
      // 含搜索功能的侧边栏显示
      tabsSearchList: [],
      tabsSearchKey: '',
      tabsLoading: false,
      curAnswerIndex: 0, // 当前答卷在答卷数组中的索引位置
      // answerIdArray: [], //已获取的答卷id数组，上一条下一条使用
      // answerArray: [], //已获取答卷数组，上一条下一条使用
      auditDetailVisible: false, // 审核详情弹层
      tooltips: {
        examineRate:
          '人工审核合格率 = 符合当前筛选条件的人工审核通过的答卷数 / 符合当前筛选条件的（人工审核通过 + 人工审核拒绝）的答卷数 * 100%',
        passedAll: ['一键通过，当前抽取基数', '的，所有未审核答卷。']
      },
      isActive: 0, // 当前激活的tab下标
      searchForm: {
        date: [],
        channel: '',
        position: [],
        answerDate: [],
        answerSheetId: ''
      },
      searchFormBak: {
        date: [],
        channel: '',
        position: [],
        answerDate: [],
        answerSheetId: ''
      }, //备份
      answerDatas: [], // 列表data
      tableLoading: false,
      // 用于显示通过/拒绝数 计算合格率
      showParams: {
        manualQcPassedNum: 0,
        manualQcFailedNum: 0
      },
      // 增加参数 agentType，表示代理类型（null=调查员，0=个人代理，1=企业代理）
      // 传入 /getTotalCount 此接口返回值里 agentType 的值即可
      agentType: null, // 2021-1-25 委托代理
      eligibleTotal: 0, // 符合条件的未审核总数
      isFirst: true,
      // 设置抽审比例弹层
      reExtractionVisible: false,
      extractionPercent: '', // 抽身比例 百分比 整数
      extractionNumber: '', // 抽身比例 份数
      currentAnswerId: '',

      channel: 0, // 保存当前答卷的渠道 0 网络 2 面访
      isDestroy: false, // 判断生命周期是否执行
      checkList: [], //表格勾选数据
      // 批量通过/批量拒绝
      mulAuditBtn: {
        title: '',
        dialogVisible: false,
        word: '',
        type: '',
        apiMsg: '',
        loading: false
      },
      // mulExamineDialogForm: {
      //   desc: ''
      // },
      batchAuditIdVisible: false, //批量审核答卷id 弹层
      batchAuditIdValue: '',
      surveyFinishTime: '', //答卷结束时间
      smartStoreVisible: false, //智能门店审核弹层
      channelOptions: [{
        value: '0',
        label: '链接&二维码'
      },{
        value: '2',
        label: '面对面访问'
      },{
        value: '5',
        label: '短信发送'
      },{
        value: '7',
        label: '电话访问'
      },{
        value: '12',
        label: '样本服务',
        children: []
      },{
        value: '17',
        label: '定向发布（企业员工）',
        children: []
      },{
        value: '18',
        label: '定向发布（外部组织）',
        children: []
      }],
      surveyFinishTime: '', //答卷结束时间
      // isSmartStore: false,
      pageLoading: true
    }
  },
  computed: {
    finalColums(){
      const hidenColumns = this.currentConfig.hiddenColumns || []
      if (!hidenColumns.length) return this.columns
      return this.columns.filter(col=>{
        return !hidenColumns.includes(col.value)
      })
    },
    getInerviewer() {
      const tab = this.tabsSearchList[this.isActive]
      return (tab && tab.interviewerName) || (tab && tab.interviewerTelephone) || '全部未审答卷'
    },
    // 计算人工审核 合格率
    examineRate() {
      const total = parseInt(this.showParams.manualQcPassedNum) + parseInt(this.showParams.manualQcFailedNum)
      if (total === 0 || isNaN(total)) {
        return 100
      } else {
        return Math.round((parseInt(this.showParams.manualQcPassedNum) / total) * 100)
      }
    },
    // 比较两个对象 是否相等 判断 取消 按钮的状态
    isCancelBtnDisabled() {
      if (!isequal(this.searchForm.date, this.searchFormBak.date)) {
        return false
      }
      if (this.searchForm.channel != this.searchFormBak.channel) {
        return false
      }
      if (!isequal(this.searchForm.position, this.searchFormBak.position)) {
        return false
      }
      if (!isequal(this.searchForm.answerDate, this.searchFormBak.answerDate)) {
        return false
      }
      if (this.searchForm.answerSheetId != this.searchFormBak.answerSheetId) {
        return false
      }
      return true
    },
    channelList() {
      return this.channel_list_options
    },
    isSmartStore() {
      return GlobalConfig.getIsSmartStore()
    },
    hiddenAside(){
      return ["jTomBpul"].includes(GlobalConfig.getSurveyId())
    }
  },
  methods: {
    // 获取定向发布子渠道
    getSubChannel() {
      subChannel(17, GlobalConfig.getSurveyId())
      .then(res => {
        if(res.data.code !== 0 || res.data.data.length === 0) return
        res.data.data.forEach(item => {
          let unit = {
            value: item.id,
            label: item.channel_name
          }
          this.channelOptions[5].children.push(unit)
        })
      })
      subChannel(18, GlobalConfig.getSurveyId())
      .then(res => {
        if(res.data.code !== 0 || res.data.data.length === 0) return
        res.data.data.forEach(item => {
          let unit = {
            value: item.id,
            label: item.channel_name
          }
          this.channelOptions[6].children.push(unit)
        })
      })
    },
    // 获取样本服务数据
    getSampleServiceData() {
      querySampleServiceByUser(GlobalConfig.getSurveyId()).then(res => {
        if(res.data.code !== 0 || res.data.data.length === 0) return
        res.data.data.forEach((item, index) => {
          let unit = {
            value: String(item.id),
            label: `第 ${index + 1} 次样本服务`
          }
          this.channelOptions[4].children.push(unit)

          this.channelList[item.id] = `样本服务-第 ${index + 1} 次样本服务`
        })
      }).catch((err) => {console.log(err)})
    },
    // 侧边栏数据
    getTabs() {
      this.tabsLoading = true
      getTotalCount(GlobalConfig.getSurveyId(), { preAudit: getStore({ name: 'proxy_is_survey_proxy' }) })
        .then(res => {
          const tabsList = (res && res.data.data) || {}
          // 整理tabsList数据
          this._handleTabsList(tabsList)
          // 整理每个tab标签的初始参数 和 查询组件的初始条件，并默认激活第一个tab
          this._handleInitParams(this.tabsList[0])
          // 获取【全部未审答卷】列表数据, 并默认查询【第一个】tab的列表数据
          this.getTableData()
        })
        .catch(e => {
          if (!this.isDestroy) this.$message.error('数据加载失败')
        })
        .finally(() => {
          this.tabsLoading = false
        })
    },
    // 行选中标识
    rowClassName({ row, rowIndex }) {
      if (rowIndex === this.curAnswerIndex) {
        return 'current_row'
      }
    },
    // 打开抽屉
    async openExamineDrawer(row, index) {
      const noNeedCheckFace = await this.checkFace()
      if(!noNeedCheckFace) {
        this.faceRecognitionVisible = true
        return
      }
      // 抽屉显隐
      this.auditDetailVisible = true
      // 当前答卷id
      this.currentAnswerId = row.id
      // 当前点击rowIndex
      this.curAnswerIndex = index
      //结束时间
      this.surveyFinishTime = row.surveyFinishTime
    },
    getPageData(current, callback) {
      getSamplingData(
        this._handleQueryParams({
          current
        })
      ).then(res => {
        callback && callback(res)
      })
    },
    //===⬇=== 一键审核/拒绝 ===⬇===
    confirmExamineDialog(data) {
      // this.$refs['examineDialogForm'].validate(valid => {
      //   if (valid) {
          // 整理参数
          const params = {
            surveyId: GlobalConfig.getSurveyId(),
            interviewerId: this.showParams.interviewerId,
            pass: this.mulAuditBtn.type === 'agree',
            // auditDescription: data,
            preAudit: getStore({ name: 'proxy_is_survey_proxy' }), // 2021-1-25 委托代理
            agentType: this.agentType // 2021-1-25 代理类型
          }
          if (this.mulAuditBtn.type === 'agree') {
            params.auditDescription = data
          }else {
            params.auditCause = data
          }
          // params.params参数设置
          params.params = {
            surveyRegion:
              (Array.isArray(this.searchFormBak.position) &&
                this.searchFormBak.position.length > 0 &&
                '中国;' + this.searchFormBak.position.join(';')) ||
              '',
            submitTimeStart: (this.searchFormBak.date && this.searchFormBak.date[0]) || '',
            submitTimeEnd: (this.searchFormBak.date && this.searchFormBak.date[1]) || '',
            channel: this.searchFormBak.channel[0],
            surveyStartTimeStart: (this.searchFormBak.answerDate && this.searchFormBak.answerDate[0]) || '',
            surveyStartTimeEnd: (this.searchFormBak.answerDate && this.searchFormBak.answerDate[1]) || '',
            answerIdLike: this.searchFormBak.answerSheetId
          }
          // 样本服务参数赋值
          if(this.searchFormBak.channel[0] === '12') {
            params.params.channel = this.searchFormBak.channel[0]
            params.params.sampleServiceId = this.searchFormBak.channel[1]
          }
          // 定向发布参数赋值
          if(this.searchFormBak.channel[0] === '17' || this.searchFormBak.channel[0] === '18') {
            params.params.channel = this.searchFormBak.channel[0]
            params.params.directedId = this.searchFormBak.channel[1]
          }
          auditBatch(params)
            .then(res => {
              if(res.data.code !== 0) {
                this.$message.error(res.data.msg || '一键审核操作失败')
                return
              }
              this.$message.success(this.mulAuditBtn.apiMsg)
              this.mulAuditBtn.dialogVisible = false
              this.getTableData()
            })
            .catch(e => {
              this.$message.error(e.message || '一键审核操作失败')
            })
            .finally(() => {
              this.mulAuditBtn.loading = false
              // 清空选中
              this.getDataTable().clearSelection()
              this.checkList = []
            })
        // } else {
        //   return false
        // }
      // })
    },
    // 打开 一键通过/拒绝 弹层
    async openOneBtn(type) {
      if (this.answerDatas && this.answerDatas.length === 0) {
        this.$message.error('当前无答卷需要审核')
        return
      }
      const noNeedCheckFace = await this.checkFace()
      if(!noNeedCheckFace) {
        this.faceRecognitionVisible = true
        return
      }
      if (type === 'refuse') {
        this.mulAuditBtn.title = '一键拒绝所有'
        this.mulAuditBtn.type = 'refuse'
        // this.oneBtn.word = '拒绝'
        this.mulAuditBtn.apiMsg = '一键拒绝操作成功'
      } else {
        this.mulAuditBtn.title = '一键通过所有'
        this.mulAuditBtn.type = 'agree'
        // this.oneBtn.word = '通过'
        this.mulAuditBtn.apiMsg = '一键通过操作成功'
      }
      this.mulAuditBtn.dialogVisible = true
    },
    //===⬆=== 一键审核/拒绝 ===⬆===
    //===⬇=== 重新抽取 ===⬇===
    trim(x) {
      if (x) {
        return x.replace(/^\s+|\s+$/gm, '')
      } else {
        return ''
      }
    },
    // 关闭 重新抽取 弹层事件
    closeReExtractionDialog() {
      this.extractionPercent = ''
      this.extractionNumber = ''
    },
    // 重新抽取 弹层 的确定
    selectExtraction() {
      const percent = this.trim(this.extractionPercent)
      const num = this.trim(this.extractionNumber)
      if (!percent && !num) {
        this.$message.error('百分比或份数有一项必须填写')
        return
      }
      if (!num) {
        const reg = /^(1)$|^100$|^[1-9][0-9]?$/ // 大于1 小于100 正整数
        if (!reg.test(percent)) {
          this.$message.error('百分比填写为1到100的正整数')
          return
        }
      }
      if (!percent) {
        const reg_num = /^[+]{0,1}(\d+)$/g
        if (!reg_num.test(num) || num > this.eligibleTotal || num < 1) {
          this.$message.error('份数填写应为大于0份，小于"未审核"答卷份数的正整数')
          return
        }
      }
      if (percent && num) {
        this.$message.error('不能同时设置百分比和份数')
        return
      }
      const params = {
        surveyId: GlobalConfig.getSurveyId(),
        interviewerId: this.showParams.interviewerId,
        agentType: this.agentType // 代理类型2021-1-25
      }
      // params.params参数设置
      params.params = {
        surveyRegion:
          (Array.isArray(this.searchFormBak.position) &&
            this.searchFormBak.position.length > 0 &&
            '中国;' + this.searchFormBak.position.join(';')) ||
          '',
        submitTimeStart: (this.searchFormBak.date && this.searchFormBak.date[0]) || '',
        submitTimeEnd: (this.searchFormBak.date && this.searchFormBak.date[1]) || '',
        channel: this.searchFormBak.channel[0],
        surveyStartTimeStart: (this.searchFormBak.answerDate && this.searchFormBak.answerDate[0]) || '',
        surveyStartTimeEnd: (this.searchFormBak.answerDate && this.searchFormBak.answerDate[1]) || '',
        answerIdLike: this.searchFormBak.answerSheetId
      }
      // 样本服务参数赋值
      if(this.searchFormBak.channel[0] === '12') {
        params.params.channel = this.searchFormBak.channel[0]
        params.params.sampleServiceId = this.searchFormBak.channel[1]
      }
      // 定向发布参数赋值
      if(this.searchFormBak.channel[0] === '17' || this.searchFormBak.channel[0] === '18') {
        params.params.channel = this.searchFormBak.channel[0]
        params.params.directedId = this.searchFormBak.channel[1]
      }
      if (num) {
        params.lotNum = parseInt(num)
      }
      if (percent) {
        params.lotPercentage = percent
      }
      // 2021-1-25 委托代理
      params.preAudit = getStore({ name: 'proxy_is_survey_proxy' })
      // 重新抽取
      this.tableLoading = true
      reSelect(params)
        .then(res => {
          if (res.data.code === 0) {
            this.page.currentPage = 1
            this.page.pageSize = 10
            this.getTableData()
          } else {
            this.$message.error('抽取失败')
          }
        })
        .catch(e => {
          this.$message.error('抽取失败')
        })
        .finally(() => {
          this.tableLoading = false
          this.reExtractionVisible = false
        })
    },
    //===⬆=== 重新抽取 ===⬆===
    // 切换侧边栏
    selectSide(idx) {
      // 保存激活位置
      this.isActive = idx
      // 初始化条件
      this.page.currentPage = 1
      // this.page.pageSize = 10
      this.clearSearchForm()
      // 选中第一个
      this.curAnswerIndex = 0

      // 整理每个tab标签的初始参数 和 查询组件的初始条件
      this._handleInitParams(this.tabsSearchList[idx])
      this.getTableData()
    },
    clearSearchForm() {
      this.searchForm.date = []
      this.searchForm.channel = ''
      this.searchForm.position = []
      this.searchForm.answerDate = []
      this.searchForm.answerSheetId = ''
    },
    // 点击确定按钮
    submitTable() {
      this.page.currentPage = 1
      // 备份查询条件
      this.searchFormBak = JSON.parse(JSON.stringify(this.searchForm))
      this.getTableData()
    },
    // 取消条件 点过确定 以后取消按钮不能点击，如果条件改变 取消按钮可点击，如果点击返回上一次 确定过的查询条件
    cancelTable() {
      // 返回 上次确定过的查询条件
      this.searchForm = JSON.parse(JSON.stringify(this.searchFormBak))
    },
    // 点击 每页显示条数 触发
    sizeChange(val) {
      this.page.currentPage = 1
      this.page.pageSize = val
      // 选中第一个
      this.curAnswerIndex = 0
      this.getTableData()
    },
    // 切换页面 （点击页码、数字、输入数字） 触发
    currentChange(val) {
      this.page.currentPage = val
      // 选中第一个
      this.curAnswerIndex = 0
      this.getTableData()
    },
    // 整理每个tab标签的初始参数 和 查询组件的初始条件
    _handleInitParams(params) {
      // 处理 查询条件 组件的初始值 显示
      const queryFilterParams = params.params || {}
      // 1.提交时间 初始化
      if (queryFilterParams.submitTimeStart) {
        this.searchForm.date = [queryFilterParams.submitTimeStart, queryFilterParams.submitTimeEnd]
      } else {
        this.searchForm.date = []
      }
      // 2.回收渠道 初始化
      if (queryFilterParams.channel) {
        if(queryFilterParams.channel == 12) {
          this.searchForm.channel = [queryFilterParams.channel, queryFilterParams.sampleServiceId]
        } else {
          this.searchForm.channel = queryFilterParams.channel
        }
      } else {
        this.searchForm.channel = ''
      }
      // 3.答卷位置 初始化
      if (queryFilterParams.surveyRegion && queryFilterParams.surveyRegion.split(';').length > 0) {
        const arr = JSON.parse(JSON.stringify(queryFilterParams.surveyRegion)).split(';')
        arr.shift() // 删除 中国;
        this.searchForm.position = arr
      } else {
        this.searchForm.position = []
      }
      // 4.开始答题时间 初始化
      if (queryFilterParams.surveyStartTimeStart) {
        this.searchForm.answerDate = [queryFilterParams.surveyStartTimeStart, queryFilterParams.surveyStartTimeEnd]
      } else {
        this.searchForm.answerDate = []
      }
      // 5.答卷ID 初始化
      if (queryFilterParams.answerIdLike) {
        this.searchForm.answerSheetId = queryFilterParams.answerIdLike
      } else {
        this.searchForm.answerSheetId = ''
      }
      // 2021-1-25 agentType
      this.agentType = params.agentType
      this.searchFormBak = JSON.parse(JSON.stringify(this.searchForm))
      // 用于显示 通过、拒绝数；保存【interviewerId】 区分质控员；控制列表查询条件
      this.showParams = params
    },
    // 整理列表查询参数
    _handleQueryParams(otherParams) {
      //isDetail 是否是详情上一条下一条所使用
      var rtnParams = {
        current: this.page.currentPage,
        size: this.page.pageSize,
        descs: 'create_time',
        surveyId: GlobalConfig.getSurveyId(),
        preAudit: getStore({ name: 'proxy_is_survey_proxy' }), // 代理类型2021-1-25
        agentType: this.agentType // 代理类型2021-1-25
      }
      // 扩展参数
      if (otherParams && Object.keys(otherParams).length > 0) {
        Object.assign(rtnParams, otherParams)
      }
      // 调查员id 即左侧tab的位置
      if (this.showParams.interviewerId) {
        rtnParams.interviewerId = this.showParams.interviewerId
      }
      // searchFormBak从备份中获取条件 主要是为了 不受二次变动的查询条件影响
      rtnParams.params = {
        surveyRegion:
          (Array.isArray(this.searchFormBak.position) &&
            this.searchFormBak.position.length > 0 &&
            '中国;' + this.searchFormBak.position.join(';')) ||
          '',
        submitTimeStart: (this.searchFormBak.date && this.searchFormBak.date[0]) || '',
        submitTimeEnd: (this.searchFormBak.date && this.searchFormBak.date[1]) || '',
        channel: this.searchFormBak.channel[0],
        surveyStartTimeStart: (this.searchFormBak.answerDate && this.searchFormBak.answerDate[0]) || '',
        surveyStartTimeEnd: (this.searchFormBak.answerDate && this.searchFormBak.answerDate[1]) || '',
        answerIdLike: this.searchFormBak.answerSheetId
      }
      // 样本服务参数赋值
      if(this.searchFormBak.channel[0] === '12') {
        rtnParams.params.channel = this.searchFormBak.channel[0]
        rtnParams.params.sampleServiceId = this.searchFormBak.channel[1]
      }
      // 定向发布参数赋值
      if(this.searchFormBak.channel[0] === '17' || this.searchFormBak.channel[0] === '18') {
        rtnParams.params.channel = this.searchFormBak.channel[0]
        rtnParams.params.directedId = this.searchFormBak.channel[1]
      }
      // 清除无用参数
      Object.keys(rtnParams.params).forEach(key => {
        // 0 不删除
        if (!rtnParams.params[key] && rtnParams.params[key] !== 0) {
          delete rtnParams.params[key]
        }
      })
      console.log(rtnParams)
      return rtnParams
    },
    // 获取答卷列表数据
    getTableData(otherParams) {
      this.tableLoading = true
      // 整理答卷列表的查询参数 并 查询
      getSamplingData(this._handleQueryParams(otherParams))
        .then(res => {
          // 设置分页
          const data = (res.data && res.data.data) || {}
          this.page.total = data.total
          this.page.currentPage = data.current
          this.page.pageSize = data.size
          // 设置列表数据
          this.answerDatas = data.records || []
          // 更新显示内容（未审核答卷数量）
          this.eligibleTotal = data.eligibleTotal // 符合条件的未审核总数
          // 更新侧边栏；第一次不用更新,侧边栏搜索框内有值不用更新
          if (!this.isFirst && !this.tabsSearchKey) {
            this._handleTabsList(data.totalCountList)
          }
          this.isFirst = false
          // 显示 通过、拒绝数；保存interviewerId 区分质控员
          this.showParams = this.tabsSearchList[this.isActive]
          if (!this.isDestroy) {
            Message.success({
              message: '数据已更新',
              duration: 1000,
              showClose: true
            })
          }
          // 如果当前查询页数 没有数据 往前一页查询一次
          if (this.answerDatas.length === 0 && this.page.currentPage != 1) {
            this.page.currentPage--
            if (this.page.currentPage > 0) {
              this.getTableData({ current: this.page.currentPage })
            }
          }
        })
        .catch(err => {
          if (!this.isDestroy) this.$message.error('数据更新失败')
        })
        .finally(() => {
          this.tableLoading = false
          // 刷新表格
          this.getDataTable() && this.getDataTable().doLayout()
          this.initTableHeight()
        })
    },
    // 整理tabsList数据: 将 全部未审答卷 放到第一位
    _handleTabsList(tabsList) {
      const list = []
      const allCount = tabsList.find(item => {
        // 没有interviewerId的 为 全部
        // 2021-1-22 item.interviewerId === null时 为全部
        if (!item.hasOwnProperty('interviewerId') || item.interviewerId === null) return item
      })
      allCount.interviewerName = '全部未审答卷'
      list.push(allCount)
      // 整理数据（将 全部 放到第一位）
      this.tabsList = list.concat(
        tabsList.filter(item => {
          // 2021-1-22 item.interviewerId !== null时 为全部以外
          if (item.hasOwnProperty('interviewerId') && item.interviewerId !== null) return item
        })
      )
      // 克隆
      this.tabsSearchList = JSON.parse(JSON.stringify(this.tabsList))
    },
    // 搜索Tabs
    searchChange(key) {
      this.tabsSearchKey = key
      // 前一次选中的调查员id
      const prevInterviewId = this.tabsSearchList[this.isActive]?.interviewerId || null
      // 过滤出结果
      this.tabsSearchList = deepClone(this.tabsList).filter(
        item =>
          item.interviewerName == '全部未审答卷' ||
          (item.interviewerName && item.interviewerName.indexOf(this.tabsSearchKey) > -1) ||
          (item.interviewerTelephone && item.interviewerTelephone.indexOf(this.tabsSearchKey) > -1)
      )
      // 只有全部
      if (this.tabsSearchList.length == 1) {
        this.selectSide(0)
      }
      // 重新定位：搜索结果中存在前一次选中的内容时，继续选中显示；不存在的话，默认选中全部
      const idx = this.tabsSearchList.findIndex(t => t.interviewerId === prevInterviewId)
      if (idx === -1) {
        this.selectSide(0)
      } else {
        this.selectSide(idx)
      }
    },
    // 列表勾选
    selectionChange(list) {
      this.checkList = list
    },
    //---- 批量通过 / 批量拒绝 ----
    // 批量通过
    async handlePass() {
      if (this.checkList.length == 0) {
        this.$message.warning('请勾选后重试')
      } else {
        const noNeedCheckFace = await this.checkFace()
        if(!noNeedCheckFace) {
          this.faceRecognitionVisible = true
          return
        }
        this.mulAuditBtn.title = '通过确认'
        this.mulAuditBtn.word = '通过'
        this.mulAuditBtn.type = 'agree'
        this.mulAuditBtn.dialogVisible = true
      }
    },
    batchAuditIdPass() {
      if (this.batchAuditIdValue.trim().length == 0) {
        this.$message.warning('请输入答卷ID')
      } else {
        this.mulAuditBtn.title = '通过确认'
        this.mulAuditBtn.word = '通过'
        this.mulAuditBtn.type = 'agree'
        this.mulAuditBtn.dialogVisible = true
      }
    },
    // 批量拒绝
    async handleRefuse() {
      if (this.checkList.length == 0) {
        this.$message.warning('请勾选后重试')
      } else {
        const noNeedCheckFace = await this.checkFace()
        if(!noNeedCheckFace) {
          this.faceRecognitionVisible = true
          return
        } 
        this.mulAuditBtn.title = '拒绝确认'
        this.mulAuditBtn.word = '拒绝'
        this.mulAuditBtn.type = 'refuse'
        this.mulAuditBtn.dialogVisible = true
      }
    },
    batchAuditIdRefuse() {
      if (this.batchAuditIdValue.trim().length == 0) {
        this.$message.warning('请输入答卷ID')
      } else {
        this.mulAuditBtn.title = '拒绝确认'
        this.mulAuditBtn.word = '拒绝'
        this.mulAuditBtn.type = 'refuse'
        this.mulAuditBtn.dialogVisible = true
      }
    },
    // 确定
    confirmMulExamineDialog(type, data) {
      if(this.mulAuditBtn.title.indexOf('一键') !== -1) {
        this.confirmExamineDialog(data)
        return
      }
      let ids = []
      if (this.batchAuditIdVisible) {
        ids = this.batchAuditIdValue.split('\n').filter(item => item)
      } else {
        ids = this.checkList.map(curVal => curVal.id)
      }
      // this.$refs['mulExamineDialogForm'].validate(valid => {
        // if (valid) {
          this.handleMultiAudit(type, ids, data)
            .then(() => {})
            .catch(err => {})
            .finally(() => {
              if (this.batchAuditIdVisible) {
                this.batchAuditIdVisible = false
                this.batchAuditIdValue = ''
              } else {
                // 清空选中
                this.getDataTable().clearSelection()
                this.checkList = []
              }
            })
        // }
      // })
    },
    handleMultiAudit(type, ids, data) {
      // this.mulAuditBtn.noLoading = true
      return new Promise((resolve, reject) => {
        const p = {
          ids: ids,
          pass: type == 'refuse' ? false : true,
          surveyId: GlobalConfig.getSurveyId(),
          preAudit: getStore({ name: 'proxy_is_survey_proxy' }) //委托代理 todo
        }
        if(type === 'agree'){
          p.auditDescription = data
        }else {
          p.auditCause = data
        }
        handleMultiAudit(p)
          .then(res => {
            if (res.data.code !== 0) {
              this.$message.error(res.data.msg || '审核失败')
              return
            }
            // this.mulAuditBtn.noLoading = false
            this.mulAuditBtn.dialogVisible = false
            this.getTableData() // 刷新列表
            resolve()
          })
          .catch(err => {
            // this.mulAuditBtn.noLoading = false
            this.mulAuditBtn.dialogVisible = false
            this.$message.error(err.message)
            reject(err)
          })
          .finally(() => {
            this.mulAuditBtn.loading = false
          })
      })
    },
    // 初始化 表格高度 并 重绘表格
    initTableHeight() {
      this.tableHeight = this.$refs.container && this.$refs.container.clientHeight - 161 - 36
      this.$nextTick(() => {
        this.getDataTable() && this.getDataTable().doLayout()
      })
    },
    getDataTable() {
      return this.$refs['examine-data-table']?.$refs['table']
    },
    async openBatchAuditId() {
      const noNeedCheckFace = await this.checkFace()
      if(!noNeedCheckFace) {
        this.faceRecognitionVisible = true
        return
      }
      this.batchAuditIdVisible = true
      this.batchAuditIdValue = ''
    },
    openSmartStore() {
      if (this.checkList.length == 0) {
        this.$message.warning('请勾选后重试')
        return
      } 
      this.smartStoreVisible = true
    },
    //智能门店添加审核描述成功后的调用
    addAuditSuccess() {
      const ids = this.checkList.map(curVal => curVal.id)
      handleMultiAudit({
        ids: ids,
        pass: true,
        surveyId: GlobalConfig.getSurveyId(),
        preAudit: getStore({ name: 'proxy_is_survey_proxy' }), //委托代理 todo
        auditDescription: ''
      })
        .then(res => {
          if (res.data.code !== 0) {
            this.$message.warning(res.data.msg)
          }
          this.getDataTable().clearSelection()
          this.checkList = []
          this.getTableData() // 刷新列表
        })
        .catch(err => {
          this.$message.warning(err.message)
        }).finally(()=>{
          this.smartStoreVisible = false
        })
    }
  },
  beforeDestroy() {
    this.isDestroy = true
  },
  created() {
    // 获取侧边栏数据 和 切换tab的初始条件
    this.getTabs()
    this.getSampleServiceData()
    this.getSubChannel()
  },
  mounted() {
    this.initTableHeight()
  }
}
</script>
<style lang="scss" scoped>
.main {
  overflow-y: auto;
  .query-cond {
    @apply pl-1;
    .query-cond-item {
      @apply ml-3 mb-3;
      ::v-deep .el-range-editor--small .el-range-separator {
        width: auto;
      }
    }
  }
  .el-date-editor--daterange.el-input__inner,
  .el-cascader,
  .el-select {
    width: 100%;
  }
  .tips {
    .i {
      @apply text-theme;
    }
    .re-select {
      @apply text-theme;
      cursor: pointer;
      &:hover {
        color: #5098fc;
        border-bottom: 1px solid #5098fc;
      }
    }
  }
  .box {
    @apply mb-4;
    .box-card {
      text-align: center;
      box-shadow: none;
      ::v-deep .el-card__body {
        @apply flex p-0;
      }
      .rate {
        @apply text-medium text-theme-black-650 leading-22;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 11px 0 13px 12px;
        .examine-tips {
          color: #ff463a;
          font-size: 18px;
          position: relative;
          top: -2px;
        }
        .rate-num {
          @apply text-theme leading-22;
          vertical-align: middle;
          text-align: right;
          display: inline-block;
        }
      }
      .man-made {
        @apply leading-22 text-theme-black-650 text-medium;
        padding: 11px 0px 13px 29px;
      }
      .all-buttons {
        padding-top: 7px;
      }
    }
  }
}
.inputb {
  ::v-deep .el-textarea__inner {
    min-height: 500px !important;
  }
  .footTip {
    position: absolute;
    left: 400px;
    bottom: 90px;
  }
}
// 重新抽审
::v-deep .reselect-dialog {
  .title {
    color: #333;
    font-size: 16px;
    span {
      color: #ff463a;
    }
  }
  .extraction {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 15px 0;
    .el-input {
      width: 80px;
      border-radius: 0;
      input {
        border: 0;
        border-radius: 0;
        border-bottom-width: 1px;
        border-bottom-style: solid;
        @apply border-theme-black-450;
      }
    }
  }
}
.btn-footer {
  @apply h-16 flex items-center justify-end pr-6;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}
// 列表行 选中状态
::v-deep .data-table.el-table .current_row {
  background-color: #fed7c0 !important;
  td {
    background-color: #fed7c0 !important;
  }
}
//表身的padding
::v-deep .el-table__row {
  .el-table__cell {
    &:nth-child(3) {
      .cell {
        padding-left: 6px;
        padding-right: 22px;
      }
    }
  }
}
//表头的padding
::v-deep .el-table__header {
  tr {
    .el-table__cell {
      &:nth-child(3) {
        .cell {
          padding-left: 6px;
          padding-right: 22px;
        }
      }
    }
  }
}
</style>
